import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';

const LogoutInfo = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  color: ${Colors['light']};
  margin-bottom: ${30 * Screen.widthRatio}px;
`;

export default LogoutInfo;
